type T = (key: string, opts?: any) => string

/** The server's message with Apollo's prefix removed: an i18n key for expected failures. */
export const photosErrorKey = (error: { message?: string } | null | undefined): string =>
  (error?.message ?? '').replace(/^GraphQL error: /, '').trim()

export const describePhotosError = (message: string, t: T): string => (/^Photos_error_[a-z_]+$/.test(message) ? t(message) : t('Common_error'))
